if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton != null) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      if(this.closest('[slot="pannel"]')) {
        this.closest('[slot="pannel"]').classList.add('inactive')
      }

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }

          this.addBogoGwp();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    addBogoGwp() {
      if(this.form.querySelector('.gwp_id') === undefined || this.form.querySelector('.gwp_id') === null) return;

      let formData = {
        "items": [{
         "id": this.form.querySelector(".gwp_product").value,
         "quantity": 1,
         "properties": {
          "_gwp": this.form.querySelector(".gwp_price").value,
          "_gwp_id": this.form.querySelector(".gwp_id").value,
          "_gwp_message": this.form.querySelector(".gwp_message").value
         }
         }]
       };

       if (this.cart) {
        formData["sections"] = this.cart.getSectionsToRender().map((section) => section.id);
        formData["sections_url"] = window.location.pathname;
        this.cart.setActiveElement(document.activeElement);
      }

       fetch(window.Shopify.routes.root + 'cart/add.js', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify(formData)
       })
       .then((response) => response.json())
        .then((response) => {
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
       })
       .catch((error) => {
         console.error('Error:', error);
       });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// BIS
(() => {
  function getCookieByName(name) {
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
      const [key, value] = cookie.trim().split("=");
      if (key === name) return value;
    }
    return null;
  }

  document.querySelector("#klaviyoBisButtonCu")?.addEventListener("click", () => {
    const emailCookie = getCookieByName("email");
    if (emailCookie) {
      document.getElementById("klaviyoBisButtonDiv").style.display = "none";
      document.getElementById("completed_message_already").style.display = "block";
    } else {
      document.getElementById("klaviyoBisButtonDiv").style.display = "none";
      document.getElementById("klaviyoBisButtonform").style.display = "block";
      document.getElementById("completed_message").style.display = "none";
    }
  });

  document.querySelector("#klaviyoBisButtonfinal")?.addEventListener("click", () => {
    const variant_val = document.getElementById("variant_val").value.trim();
    const email_val = document.getElementById("email_sub").value;
    if (!variant_val || !email_val) {
      document.getElementById("error_msg").style.display = "block";
      document.getElementById("email_sub").style.borderColor = "red";
      return;
    }

    const payload = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "company_id": "HEwgpW",
          "profile": {
            "data": {
              "type": "profile",
              "attributes": { "email": email_val }
            }
          },
          "channels": ["EMAIL"]
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": `$shopify:::$default:::${variant_val}`
            }
          }
        }
      }
    };

    fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "revision": "2024-06-15"
  },
  body: JSON.stringify(payload)
})
  .then((response) => {
    console.log(`HTTP Status: ${response.status}`);
    if (!response.ok && response.status !== 202) {
      console.error(`Server error: ${response.statusText}`);
      return Promise.reject(`HTTP Error ${response.status}`);
    }
    // Check if the response has a body
    if (response.headers.get("Content-Length") === "0") {
      console.log("Empty response body");
      return {}; // Return an empty object to avoid parsing errors
    }
    return response.json(); // Parse only if there is a body
  })
  .then((data) => {
    console.log("Response data:", data);
    // Handle success case based on your application's logic
    document.cookie = `email=${email_val}; path=/`;
    document.getElementById("klaviyoBisButtonform").style.display = "none";
    document.getElementById("completed_message").style.display = "block";
  })
  .catch((err) => console.error("Fetch error:", err));
  });
})();